(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["quantity-breaks"] && !Shopify.designMode) return;
  try {
    (function () {

  function fmtMoney(cents, currency, locale) {
    return new Intl.NumberFormat(locale || 'fr-FR', {
      style: 'currency',
      currency: currency
    }).format(cents / 100);
  }


  function initQtyBreaks(container) {

    var opts = container.querySelectorAll('.nourrie-qty-opt');

    if (!opts.length) {
      return;
    }

    var basePrice = parseInt(
      container.getAttribute('data-base-price'),
      10
    );

    var currency =
      container.getAttribute('data-currency') || 'EUR';


    if (isNaN(basePrice)) {
      return;
    }


    var state = {
      qty: 1,
      discount: 0
    };


    /*
     * Prix du bouton Ajouter au panier
     */
    var originalPriceSpans =
      document.querySelectorAll('[data-atc-price-original]');

    var priceSpans =
      document.querySelectorAll('[data-atc-price]');


    function updateTotal() {

      var original =
        Math.round(basePrice * state.qty);

      var total =
        Math.round(
          basePrice *
          state.qty *
          (1 - state.discount)
        );


      var formattedTotal =
        fmtMoney(
          total,
          currency,
          document.documentElement.lang
        );


      priceSpans.forEach(function (span) {
        span.textContent = formattedTotal;
      });


      originalPriceSpans.forEach(function (span) {

        if (state.discount > 0) {

          span.textContent =
            fmtMoney(
              original,
              currency,
              document.documentElement.lang
            );

          span.hidden = false;

        } else {

          span.hidden = true;

        }

      });

    }


function updateQuantityInput() {

  var input = document.querySelector(
    'input[name="quantity"]'
  );

  if (!input) {
    console.log('Input quantité introuvable');
    return;
  }

  input.value = String(state.qty);

  input.dispatchEvent(
    new Event('input', {
      bubbles: true
    })
  );

  input.dispatchEvent(
    new Event('change', {
      bubbles: true
    })
  );

  console.log(
    'Quantité mise à jour :',
    state.qty
  );
}



    function setActive(opt) {

      if (!opt) {
        return;
      }


      opts.forEach(function (item) {

        item.classList.remove(
          'nourrie-qty-opt--active'
        );

        item.setAttribute(
          'aria-pressed',
          'false'
        );

      });


      opt.classList.add(
        'nourrie-qty-opt--active'
      );

      opt.setAttribute(
        'aria-pressed',
        'true'
      );


      state.qty =
        parseInt(
          opt.getAttribute('data-qty'),
          10
        ) || 1;


      state.discount =
        parseFloat(
          opt.getAttribute('data-discount')
        ) || 0;


      /*
       * IMPORTANT :
       * La quantité est mise à jour AVANT le prix.
       */
      updateQuantityInput();

      updateTotal();

    }


    opts.forEach(function (opt) {

      opt.addEventListener(
        'click',
        function (event) {

          event.preventDefault();

          setActive(opt);

        }
      );

    });


    /*
     * Initialise le bouton actif.
     */
    var initialOpt =
      container.querySelector(
        '.nourrie-qty-opt--active'
      ) || opts[0];


    setActive(initialOpt);

  }


  function initAll() {

    document
      .querySelectorAll('[data-qty-breaks]')
      .forEach(function (container) {

        /*
         * Évite une double initialisation
         * si Shopify recharge une partie de la page.
         */
        if (
          container.dataset.qtyBreaksInitialized === 'true'
        ) {
          return;
        }


        container.dataset.qtyBreaksInitialized = 'true';

        initQtyBreaks(container);

      });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }

})();
  } catch(e) { console.error(e); }
})();

})();
